import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", "aria-hidden": "true", width: "1em", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 6L14 10L6 14V6Z", fill: "currentColor" }));
export default SvgArrowRight;
